import { QueryConfig } from "react-query";
import { useUser } from "context";
import type { Credits } from "types/generated";
import { useTeamCredits } from "./useTeamCredits";

export const useCurrentTeamCredits = (options?: {
  query?: QueryConfig<Credits, void>;
}) => {
  const [{ currentTeam }] = useUser();
  const { enabled = true, ...queryOptions } = options?.query || {};
  return useTeamCredits(currentTeam?.id || 0, {
    query: {
      ...queryOptions,
      enabled: !!currentTeam?.id && !!enabled,
    },
  });
};
